import React, { Component, } from 'react'

import {CCActivityIndicator,  ImageUtils, CCIcon} from './../../cc-imports'

import PropTypes from 'prop-types'

import './../../styles/css/components/CCDp/cc-dp.css'

class CCDp extends Component {

    static propTypes = {

        onPress:PropTypes.func,
        disabled : PropTypes.bool,
        user : PropTypes.object,
        loading : PropTypes.bool,
        editable : PropTypes.bool,
        isWinner : PropTypes.bool,

        imageClassName : PropTypes.string,
        className:PropTypes.string,
        imgClass:PropTypes.string

    }

    static defaultProps = {
        onPress:()=>{},
        disabled : false,
        picture : {},
        loading : false,
        editable : false,
        isWinner : false,

        imageClassName : '',
        className:'',
        imgClass: ''
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {imageClassName, className, imgClass} = this.props;
        return (
            <div  onClick={this.props.onPress} style={{position:'relative'}} disabled={this.props.disabled}>
                    {
                        this.props.loading ?
                            <CCActivityIndicator size="s"/>
                            :
                            <img className={imgClass} src={ImageUtils.getProfilePicSrc(this.props.user)}/>
                    }
                    {
                        (this.props.user.id && this.props.editable && !this.props.loading) &&
                        <div className="flex-container cc-dp-edit-overlay" >
                            <CCIcon onClick={this.props.onPress} className={'cc_icon_xxxs'} type={'plus'}/>
                        </div>
                    }
            </div>
        )
    }
}

export default CCDp


// WEBPACK FOOTER //
// ./src/app/components/CCDp/CCDp.js